import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import get from 'lodash/get';
import values from 'lodash/values';
import { 
  getActiveAgencyUser,
  getAllPaymentMethodsForAgency,
  getPaymentMethodsForAgency
} from '../../shared/redux/selectors';

import {
  loadAgency,
  loadPaymentMethodsForAgency,
  updateAgency,
  createPaymentMethod,
  deletePaymentMethod
} from '../../shared/redux/entities/actions';

import {
  loadAccountHistory,
  addFundsToAgency
} from '../../shared/redux/accounting/actions';


function getCampaignsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.campaigns)
      .filter((c) => c.agencyId === agencyId);

  } else {
    return [];
  }
}

function mapStateToProps(state){
  const activeUser = getActiveAgencyUser(state);

  return {
    activeUser:activeUser,
    activeAgency:get(state,['entities','agencies',activeUser.agencyId],{}),
    activePaymentMethods:getPaymentMethodsForAgency(state,activeUser.agencyId),
    allPaymentMethods:getAllPaymentMethodsForAgency(state,activeUser.agencyId),
    allCampaigns:getCampaignsForAgency(state,activeUser.agencyId)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to ManageAccount
  return bindActionCreators({
    deletePaymentMethod,
    createPaymentMethod,
    loadPaymentMethodsForAgency,
    updateAgency,
    loadAgency,
    loadAccountHistory,
    addFundsToAgency
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/ManageAccount/connect.js